<template>
  <div class="main-container">
    <toast-message
      :message="errmsg"
      :isToastEnable="toast"
      type="error"
      @close="(val) => toast = val"
    />
    <breadcrumb :list="breadcrumbList" />

    <tl-header type="h1">
      <div class="main-header margintop-30">Process FBP Configuration</div>
    </tl-header>
    <tl-checkbox
      class="headcheck margin-t-m"
      name="push_declaration"
      label="Push Declaration"
      v-model="formData.push_declaration"
    />
    <pop-up-message
      v-if="showSuccessMsg"
      :message="responseMsg"
      btnText="Back"
      @back="backfrompopup"
    ></pop-up-message>
    <bottom-action-container class="custom-width">
      <template slot="end">
        <btn-grp>
          <btn text="Back" type="secondary" @click="back" />
          <btn text="Process" type="primary" @click="process" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  data() {
    return {
      breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`,
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll`,
        },
        {
          name: "Process FBP Configuration",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`,
        },
      ],
      formData: {
        push_declaration: false,
        fbp_year: ""
      },
      errmsg: "",
      showSuccessMsg: false,
      toast: false,
    };
  },
  mounted() {
  },
  activated(){
  },
  computed: {
    ...mapState({
      globalEmployeeList: (state) =>
        state.globalapi.globalemployees.entityWiseData,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    le_id() {
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
    requestParams() {
      return {
        le_id: this.le_id,
      };
    },
    ...mapState("onboard/organization", {
      orgId: (state) => state.id,
    }),
    ifTeamleaderAnchorPermission() {
      if (
        this.role === "TEAMLEADER" ||
        this.role === "ANCHOR" ||
        this.role === "ADMIN"
      ) {
        if (this.companyValue) {
          return true;
        } else {
          return false;
        }
      }
    },
  },
  methods: {
    ...mapActions({
      act_create:"dashboard/payroll/utilities/pushFbpConfiguration/create",
    }),

    async process() {
        //{"le_id":"3502a45d-063a-4deb-9e64-d7f60d8148e0","push_declaration":true,"fbp_year":2023}
      try {
          this.formData.le_id = this.le_id;
          this.formData.fbp_year = 2023;
          let res = await this.act_create(this.formData);
          if (res.data && res.data.status) {
            this.responseMsg = res.data.message ? res.data.message : "";
            this.showSuccessMsg = true;
          } else {
            this.toast = true;
            this.errmsg = res.message;
          }
        
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    back() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/fbpPayroll`
      });
    },

    /* function to hide successpop-up and go back to main cost centre page */
    backfrompopup() {
      this.showSuccessMsg = false;
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/fbpPayroll`,
      });
    },
    
  },
};
</script>
<style lang="scss" scoped>
.filters {
  display: grid;
  grid-gap: 10px;
  grid-template: auto / repeat(4, minmax(180px, 1fr));
}
.bottom-line {
  border-bottom: 1px solid #34c0be;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 5%;
}
.label {
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 10px;
  color: #6e6e6e;
}
.btn-center {
  margin: auto;
}
.input-checkbox {
  height: 20px;
  width: 20px;
}
.dropdown-box-design {
  border: 1px solid #e7e7e7;
  padding: 20px 4px 20px 20px;
  border-radius: 3px;
  background: #f9f9f9;
  max-width: 300px;
}
.text-capital {
  text-transform: capitalize;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 2px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>